import { useQuery } from 'react-query';
import { QueryKeys } from '@frontend/features/common/types';
import { PagedFilter, PagedResponse} from '@bandido/shared/dist/dtos';
import { AxiosError, AxiosResponse } from 'axios';
import { client } from '@frontend/features/common/services';
import { HotelIntegrationDto, HotelIntegrationListDto } from '@bandido/shared/dtos';

export interface useGetAllHotelIntegrationsProps extends PagedFilter {
  onErrorCallback?: (_e: AxiosError) => void;
  search?: string;
}

export const useGetAllHotelIntegrations = ({
  currentPage,
  onErrorCallback,
  pageSize,
  search,
}: useGetAllHotelIntegrationsProps) =>
  useQuery({
    queryKey: [QueryKeys.getAllHotelIntegrations, currentPage, pageSize, search],
    queryFn: async (): Promise<PagedResponse<HotelIntegrationListDto> | undefined> => {
      try {
        const hotelIntegrations: AxiosResponse<PagedResponse<HotelIntegrationListDto>, any> = await client.get(
          'hotel-integrations',
          {
            params: {
              currentPage,
              pageSize,
              search,
            },
          },
        );

        return hotelIntegrations.data;
      } catch (e) {
        onErrorCallback && onErrorCallback(e as AxiosError);
      }
    },
    refetchOnWindowFocus: true,
  });

export const useGetHotelIntegrationById = (id: string) => {
  return useQuery([QueryKeys.getAHotelIntegrationById, id], async ():Promise<HotelIntegrationDto> => {
    const { data } = await client.get(`/hotel-integrations/${id}`);
    return data;
  });
};
